import createNamespaceContext from './helper/createNamespaceContext';
export var MEDIA_CONTEXT = 'mediaCtx';
export var MediaAnalyticsContext = createNamespaceContext(MEDIA_CONTEXT, 'MediaAnalyticsContext');
//# sourceMappingURL=MediaAnalyticsContext.js.map